import "./styles.css";

export default function Form({ title, subtitle, onSubmit, children, className = "" }) {
  return (
    <form onSubmit={onSubmit} className={`form-container ${className}`}>
      {title && <h1 className="form-title">{title}</h1>}
      {subtitle && <p className="form-subtitle">{subtitle}</p>}
      {children}
    </form>
  );
}
